import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const createLead = (data) => axios.post(`${API}/leads`, data);

export const track = (event, service, meta) => {
  axios.post(`${API}/track`, { event, service, meta }).catch(() => {});
};
